import { Component, OnInit } from '@angular/core';
import { UserService } from '@/core/services/open-api/user.service';
import { FormControl, Validators } from '@angular/forms';
import { ToastService } from '@/core/services/toast.service';
// import { strictEmailValidator } from '@/common/validators/email.validator';

@Component({
    selector: 'app-lost-password-page',
    templateUrl: './lost-password.component.html',
    // styleUrls: ['./lost-password.component.scss'],
    standalone: false,
})
export class LostPasswordComponent implements OnInit {
    // old pattern: "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
    emailControl = new FormControl('', [Validators.required, Validators.email]);
    email = '';
    displayValidationMessages = false;
    isLoading = false;
    submitSuccess = false;
    submitError = false;

    constructor(
        private userService: UserService,
        private toastService: ToastService,
    ) {}

    ngOnInit(): void {}

    public lostPassword(): void {
        if (this.emailControl.invalid) {
            this.displayValidationMessages = true;
            return;
        }

        const email = this.emailControl.value;
        if (email) {
            this.isLoading = true;
            this.submitError = false;
            this.userService.requestPasswordReset(email).subscribe({
                next: () => {
                    this.isLoading = false;
                    this.submitSuccess = true;
                    this.emailControl.disable();
                    this.toastService.success('standard_success', 'public_lostpassword_resetlinksent');
                },
                error: () => {
                    this.isLoading = false;
                    this.submitError = true;
                    this.toastService.error('standard_error', 'public_lostpassword_resetnotsent');
                },
            });
        }
    }
}
